import { PlanTerm, SubscriptionTier } from "@util/constants.ts";

export const TIER_LABELS: Record<SubscriptionTier, string> = {
  [SubscriptionTier.FREE]: "Free",
  [SubscriptionTier.GROWTH]: "Growth",
  [SubscriptionTier.SCALE]: "Scale",
  [SubscriptionTier.ENTERPRISE]: "Enterprise",
  [SubscriptionTier.OTHER]: "Enterprise Trial",
};

const fullTierLabel = (tier: SubscriptionTier, planTerm: PlanTerm) =>
  `${TIER_LABELS[tier]}${
    tier === SubscriptionTier.SCALE
      ? planTerm === PlanTerm.ANNUAL
        ? " Yearly"
        : " Monthly"
      : ""
  }`;

export default fullTierLabel;
